import { useState } from "react";
import { ImageOff } from "lucide-react";

export default function CoverImage({ coverUrl, alt, className, ...props }) {
  const [failed, setFailed] = useState(false);

  if (!coverUrl || failed) {
    return (
      <div
        {...props}
        className={`${className} flex items-center justify-center bg-secondary text-muted-foreground`}
        role="img"
        aria-label={alt || "Cover image unavailable"}
      >
        <ImageOff size={24} strokeWidth={1.5} />
      </div>
    );
  }

  return (
    <img
      {...props}
      src={coverUrl}
      alt={alt}
      className={className}
      onError={() => setFailed(true)}
    />
  );
}